import { Scopes, createServiceModule } from '@aesop-fables/containr';
import {
  BasePricebookOptionsSubject,
  PricebookOptionsSubject,
  PricebookSelectionsSubject,
  OrgAvailablePricebooksSubject,
  GroupAvailablePricebooksSubject,
  TeamAvailablePricebooksSubject,
} from './subjects/PricebookSubject';

export const PricebookServices = {
  PricebookOptions: 'pricebook/subjects/OrgPricebookOptions',
  PricebookSelections: 'pricebook/subjects/PricebookSelections',
  BasePricebookOptions: 'pricebook/subjects/BaseOrgPricebookOptions',
  OrgAvailablePricebooks: 'pricebook/subjects/OrgAvailablePricebooks',
  TeamAvailablePricebooks: 'pricebook/subjects/TeamAvailablePricebooks',
  GroupAvailablePricebooks: 'pricebook/subjects/GroupAvailablePricebooks',
};

export const usePricebookServiceModule = createServiceModule('pricebook/services', services => {
  services.autoResolve(
    PricebookServices.PricebookOptions,
    PricebookOptionsSubject,
    Scopes.Transient,
  );
  services.autoResolve(
    PricebookServices.PricebookSelections,
    PricebookSelectionsSubject,
    Scopes.Transient,
  );
  services.autoResolve(
    PricebookServices.BasePricebookOptions,
    BasePricebookOptionsSubject,
    Scopes.Transient,
  );
  services.autoResolve(
    PricebookServices.OrgAvailablePricebooks,
    OrgAvailablePricebooksSubject,
    Scopes.Transient,
  );
  services.autoResolve(
    PricebookServices.TeamAvailablePricebooks,
    TeamAvailablePricebooksSubject,
    Scopes.Transient,
  );
  services.autoResolve(
    PricebookServices.GroupAvailablePricebooks,
    GroupAvailablePricebooksSubject,
    Scopes.Transient,
  );
});
